import type { AddKeyRequest, EditKeyRequest } from './types';

// eslint-disable-next-line import/prefer-default-export
export const prepareFormDataForKeyMutation = (data: AddKeyRequest | EditKeyRequest) => {
    const formData = new FormData();

    formData.append('action', 'get_key_data');
    formData.append('akey', data.keyName.ios);
    formData.append('akey_android', data.keyName.android);
    formData.append('akey_other', data.keyName.other);
    formData.append('akey_web', data.keyName.web);
    formData.append('use_project_automations', data.useProjectAutomations ? '1' : '0');
    formData.append('context', data.context);
    formData.append('char_limit', data.charLimit);
    formData.append('description', data.description);
    formData.append('plural', data.pluralValue);
    formData.append('plural_forms', data.plural ? JSON.stringify(data.plural) : '');
    formData.append('new_filename', data.newFilename);
    formData.append('filename_ios_id', data.filenames.ios);
    formData.append('filename_android_id', data.filenames.android);
    formData.append('filename_web_id', data.filenames.web);
    formData.append('filename_other_id', data.filenames.other);
    formData.append('device_id', data.deviceId);
    formData.append('tags', data.tags);
    formData.append('hidden', JSON.stringify(data.hidden));
    formData.append('project_id', data.projectId);
    formData.append('current_view', data.currentView);
    formData.append('single_lang_id', JSON.stringify(data.singleLangId || ''));
    formData.append('reference_lang_id', JSON.stringify(data.referenceLangId || ''));
    formData.append('temp_screenshots', data.tempScreenshots); // TODO: Everytime sends empty value, should be checked on BE
    formData.append('custom_attributes', data.customAttributes);
    formData.append('key_type', data.keyType);
    formData.append('branch', data.branch);

    if (typeof data.baseValue !== 'undefined') {
        formData.append('base_value', data.baseValue);
    }

    return formData;
};
